import React, { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  LazyLoadImage,
  trackWindowScroll,
} from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import notfound from "../assets/image/notfoundimage.jpg";
import placeholder from "../assets/image/cardplaceholder.gif"; // Import your placeholder image
import Loading from "./Loading";
import newnew from "../assets/image/new.png";
const MovieCard = (props, { scrollPosition }) => {
  const navigate = useNavigate();
  const deleteHandler = () => {
    const existingList =
      JSON.parse(localStorage.getItem("selectedMovies")) || [];
    const updatedList = existingList.filter(
      (movie) => movie.id !== props.movie.id
    );
    localStorage.setItem("selectedMovies", JSON.stringify(updatedList));
    if (props.onDelete) {
      props.onDelete(updatedList); // Notify parent component to update UI
    }
  };
  const clickhandler = () => {
    const existingList =
      JSON.parse(localStorage.getItem("selectedMovies")) || [];
    const isDuplicate = existingList.some(
      (movie) => movie.id === props.movie.id
    );
    if (!isDuplicate) {
      existingList.push(props.movie);
      if (existingList.length > 10) {
        existingList.shift(); // Remove the oldest item
      }
      localStorage.setItem("selectedMovies", JSON.stringify(existingList));
    }
    if (props.filterType) {
      if (props.filterType.isMovieChecked) {
        navigate("/movie", { state: { key: props.movie.id } });
      } else if (props.filterType.isTvChecked) {
        navigate("/tv", { state: { key: props.movie.id } });
      } else if (props.filterType.isPersonChecked) {
        navigate("/person", { state: { key: props.movie.id } });
      } else {
        navigate(`/${props.movie.media_type}`, {
          state: { key: props.movie.id },
        });
      }
    } else {
      navigate(`/${props.movie.media_type}`, {
        state: { key: props.movie.id },
      });
    }
  };

  const imageUrl = props.movie.poster_path
    ? `https://image.tmdb.org/t/p/w342${props.movie.poster_path}`
    : props.movie.profile_path
    ? `https://image.tmdb.org/t/p/w342${props.movie.profile_path}`
    : notfound;

  const date = new Date();
  const last = new Date(date.getTime() - 30 * 24 * 60 * 60 * 1000);
  const day = last.getDate();
  const month = last.getMonth() + 1;
  const year = last.getFullYear();
  const separator = "-";
  const today = `${year}${separator}${
    month < 10 ? `0${month}` : `${month}`
  }${separator}${day}`;
  return (
    <motion.div
      className={`movie-card-main-container group ${
        props.isRecentlyViewed ? "scale-100" : "hover:scale-[1.05]"
      } hover:cursor-pointer duration-500 z-40 rounded`}
      onClick={clickhandler}
      whileTap={props.isRecentlyViewed ? {} : { scale: 0.85 }}
    >
      {props.isRecentlyViewed && (
        <>
          <button
            className="absolute top-1 left-0 text-red-600 hover:text-red-800 md:text-2xl text-lg z-50"
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering the card click
              deleteHandler();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="32"
              height="32"
              viewBox="0 0 48 48"
            >
              <path
                fill="#f44336"
                d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
              ></path>
              <path
                fill="#fff"
                d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z"
              ></path>
              <path
                fill="#fff"
                d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z"
              ></path>
            </svg>
          </button>
        </>
      )}
      <div className="movie-card-image-container relative">
        <Suspense
          fallback={
            <div className="loader">
              <Loading />
            </div>
          }
        >
          <div className="absolute inset-0 pointer-events-auto rounded group-hover:border-yellow-400 group-hover:border-2" />
          <LazyLoadImage
            src={imageUrl}
            alt={props.movie.title || props.movie.name}
            scrollPosition={scrollPosition}
            placeholderSrc={placeholder} // Show placeholder image
            className={`transition-opacity duration-1000 rounded ease-in-out w-[95px] h-[140px] md:w-[150px] md:h-[225px]`}
          />

          {props.filterType ? (
            props.movie.release_date > today ||
            props.movie.first_air_date > today ? (
              <>
                <div className="absolute inset-0 pointer-events-auto" />
                <>
                  {
                    <LazyLoadImage
                      src={newnew}
                      className="absolute top-0 right-0 w-6 md:w-8 animate-pulse"
                    />
                  }
                </>
              </>
            ) : (
              <></>
            )
          ) : (
            <>
              {props.movie.media_type === "movie" ||
              props.movie.media_type === "tv" ? (
                props.movie.release_date > today ||
                props.movie.first_air_date > today ? (
                  <>
                    <div className="absolute inset-0 pointer-events-auto" />

                    <>
                      {
                        <LazyLoadImage
                          src={newnew}
                          className="absolute top-0 right-0 w-6 md:w-8 animate-pulse"
                        />
                      }
                    </>
                  </>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}{" "}
            </>
          )}
          {props.movie.media_type === "tv" || props.filterType?.isTvChecked ? (
            <>
              <div className="absolute inset-0 pointer-events-auto" />
              <div className="absolute top-0 left-0 flex items-center space-x-1 ">
                <span
                  className={`text-xs opacity-0  font-bold text-black  bg-amber-400 px-1 py-0.5 rounded ${
                    props.isRecentlyViewed
                      ? ""
                      : "opacity-0 group-hover:opacity-100"
                  } transform translate-x-16 group-hover:translate-x-0 ease-in-out duration-500 ${
                    props.isRecentlyViewed ? "" : "delay-400"
                  } `}
                >
                  TV
                </span>
              </div>
            </>
          ) : props.movie.media_type === "movie" ||
            props.filterType?.isMovieChecked ? (
            <>
              <div className="absolute inset-0 pointer-events-auto" />
              <div className="absolute top-0 left-0 flex items-center space-x-1 ">
                <span
                  className={` opacity-0 text-xs  font-bold text-black bg-amber-400 px-1 py-0.5 rounded ${
                    props.isRecentlyViewed
                      ? ""
                      : "opacity-0 group-hover:opacity-100"
                  } transform translate-x-16 group-hover:translate-x-0 ease-in-out duration-500 ${
                    props.isRecentlyViewed ? "" : "delay-500"
                  }`}
                >
                  MOVIE
                </span>
              </div>
            </>
          ) : (
            <></>
          )}

          {/* Vote Count as Stars */}
          {props.movie.media_type !== "person" && (
            <div
              className={`absolute bottom-0 opacity-0 left-1/2 transform -translate-x-1/2 bg-yellow-400 px-2 py-0.5 rounded text-xs font-bold text-black flex items-center space-x-1 ${
                props.isRecentlyViewed
                  ? ""
                  : "opacity-0 group-hover:opacity-100"
              } transform translate-y-4 group-hover:translate-y-0 ease-in-out duration-500 ${
                props.isRecentlyViewed ? "" : "delay-500"
              }`}
            >
              {Array.from({ length: 5 }).map((_, index) => {
                const starValue = index + 1;
                const voteAverage = props.movie.vote_average / 2; // Convert to 5-star scale

                return (
                  <svg
                    key={index}
                    xmlns="http://www.w3.org/2000/svg"
                    fill={
                      starValue <= voteAverage
                        ? "currentColor" // Full star
                        : starValue - 0.5 <= voteAverage
                        ? "url(#half-star)" // Half star
                        : "none" // Empty star
                    }
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    className="w-4 h-4 text-black"
                  >
                    <defs>
                      <linearGradient id="half-star">
                        <stop offset="50%" stopColor="currentColor" />
                        <stop offset="50%" stopColor="none" />
                      </linearGradient>
                    </defs>
                    <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.857 1.428 8.837L12 18.896l-7.364 4.104 1.428-8.837-6.064-5.857 8.332-1.151z" />
                  </svg>
                );
              })}
            </div>
          )}
        </Suspense>
      </div>
      {/* Movie Name */}
      <div
        className={`movie-card-title-container w-[95px] md:w-[150px] mt-1 opacity-0 ${
          props.isRecentlyViewed ? "" : "opacity-0 group-hover:opacity-100"
        } transform -translate-y-4 group-hover:translate-y-0 ease-in-out duration-500 ${
          props.isRecentlyViewed ? "" : "delay-500"
        }`}
      >
        <span
          className={`opacity-0 transition-all delay-500 line-clamp-1 z-50 newfont font-extrabold uppercase rounded bg-yellow-400 text-[0.6rem] text-black ${
            props.isRecentlyViewed ? "" : "group-hover:opacity-100"
          }`}
        >
          {props.movie.name || props.movie.title}
        </span>
      </div>
    </motion.div>
  );
};

export default trackWindowScroll(MovieCard);
